import { styled } from '@linaria/react';
import { colors, fonts, layout } from '../../theme/tokens';

export { Badge, IconWrapper } from '../../styles/nav.styles';

export const Rail = styled.nav`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 72px;
    height: 100vh;
    padding-top: 20px;
    gap: 4px;
    border-right: 1px solid ${colors.borderGrey};
    background: ${colors.white};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }
`;

export const TopItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const BottomItems = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: 20px;
`;

export const NavItem = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 4px;
  width: 64px;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? colors.fontPrimary : colors.grey)};
  transition: color 0.15s ease, background 0.15s ease;

  &:hover {
    color: ${colors.fontPrimary};
    background: ${colors.lighterGrey};
  }
`;

export const NavLabel = styled.span`
  font-family: ${fonts.body};
  font-size: 0.625rem;
  font-weight: ${fonts.weight.medium};
  letter-spacing: 0.2px;
`;
